/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_Ended_AtInputs */

const vi_trip_ended_at = /** @type {(inputs: Trip_Ended_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kết thúc`)
};

/**

* @param {Trip_Ended_AtInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_ended_at = /** @type {((inputs?: Trip_Ended_AtInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_Ended_AtInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_ended_at(inputs)
});